import { useIntercom } from "react-use-intercom";
import PrimaryButton from "../../../Components/Buttons/primary-button";

import { useModalContext } from "../../../Contexts/ModalContext";

import { modalVariants } from "../../../Utils/constants";

import { StakeCardFrontSide } from "../../../Assets/Images";
import { CircleExclamationOutlined } from "../../../Assets/Icons";

export default function renderStakeCheckingDenied(modalContext) {
  const {
    updateModalComponent,
    pushModalStack,
    setModalVariant,
    setModalPromoComponent,
    setModalTitle,
    setModalClassName,
  } = modalContext;

  updateModalComponent(StakeCheckingDenied);
  pushModalStack(() => renderStakeCheckingDenied(modalContext));
  setModalPromoComponent(null);
  setModalTitle("");
  setModalClassName("hide-header no-full-screen");
  setModalVariant(modalVariants.flexDialog);
}

const StakeCheckingDenied = () => {
  const { popModalStack } = useModalContext();

  const { show: showIntercom } = useIntercom();

  return (
    <>
      <div className="modal-dialog-content mt-6">
        <img className="stake-card-front-side" src={StakeCardFrontSide} alt="" />
        <h3 className="modal-status-title mt-6 mb-5">Your Stake Checking application was rejected.</h3>
        <div className="info-alert error">
          <CircleExclamationOutlined />
          <div>
            We’re unable to approve your application
            <div className="text-xs-regular mt-1">
              We’re sorry, but we can’t approve your Stake Checking application at this time. If you have questions,
              contact Support.
            </div>
          </div>
        </div>
      </div>
      <div className="action-container">
        <PrimaryButton
          onClick={() => {
            showIntercom();
            popModalStack(1);
          }}
        >
          Contact Support
        </PrimaryButton>
        <PrimaryButton className="secondary-colors" onClick={() => popModalStack(1)}>
          Close
        </PrimaryButton>
      </div>
    </>
  );
};
